import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "98",
  height: "105",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#211F1F",
  d: "M91.405 83.334H5.632c-3.078 0-5.581 2.512-5.581 5.599 0 3.083 2.503 5.592 5.581 5.592h85.773c3.074 0 5.575-2.509 5.575-5.592 0-3.087-2.5-5.599-5.575-5.599m-10.679-10.7V46q0-.608-.023-1.212c-9.625-.843-17.201-8.964-17.201-18.825 0-2.706.57-5.28 1.596-7.609a31.9 31.9 0 0 0-16.58-4.642C30.76 13.71 16.312 28.195 16.312 46v26.635c0 2.886-1.149 5.507-3.009 7.433h70.433a10.67 10.67 0 0 1-3.009-7.434M54.24 10.912V5.746C54.24 2.578 51.673 0 48.517 0c-3.159 0-5.729 2.578-5.729 5.746v5.165a35.3 35.3 0 0 1 11.451.002m-5.723 93.605c4.035 0 7.409-2.896 8.167-6.725h-16.34c.76 3.829 4.135 6.725 8.173 6.725"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF1D25",
  d: "M82.357 10.324c8.597 0 15.591 7.016 15.591 15.639 0 8.62-6.994 15.633-15.59 15.633-8.598 0-15.592-7.013-15.592-15.633 0-8.623 6.994-15.639 15.591-15.639m0 22.316a1.635 1.635 0 0 0-1.155 2.788 1.634 1.634 0 0 0 2.31-2.31 1.63 1.63 0 0 0-1.155-.478m0-16.626a1.635 1.635 0 0 0-1.633 1.634v11.74a1.635 1.635 0 0 0 2.788 1.155c.306-.306.478-.722.478-1.155v-11.74a1.634 1.634 0 0 0-1.633-1.634"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }